const spliceFileResource = resource => {
  return function({ state, props, resolve }) {
    const resourcePath = resolve.value(resource)
    const { selectedFiles, tags: { showShared } } = state.get('media')
    const files = showShared ? selectedFiles : [props.id]
    const indexes = []
    files.forEach(id => {
      const currentResource = state.get(`media.files.${id}.${resourcePath}`)
      const index = currentResource.indexOf(props.value)
      state.splice(`media.files.${id}.${resourcePath}`, index, 1)
      indexes.push(index)
    })

    return { indexes }
  }
}

export default spliceFileResource



// WEBPACK FOOTER //
// ./src/modules/Media/factories/spliceFileResource.js